<template>
    <div
        class="w-full rounded-lg flex flex-col justify-center items-center p-8 mt-6"
    >
        <HeaderIcon>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#5F6D7E" style="opacity:1;"><path  d="M17.084 15.812a7 7 0 1 0-10.168 0A6 6 0 0 1 12 13a6 6 0 0 1 5.084 2.812M12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 12a3 3 0 1 1 0-6a3 3 0 0 1 0 6"/></svg>
        </HeaderIcon>

        <div class="w-full max-w-lg flex flex-col justify-center items-center mt-8 z-50">
            <Intro :heading-text="headingText" :sub-text="subText" />

            <div class="w-full max-w-sm flex flex-col">
                <div class="mb-3 mt-6">
                    <label
                        for="phone"
                        class="block text-sm font-semibold text-primary-font"
                    >
                        Phone
                    </label>
                    <div
                        class="flex items-center mt-1"
                    >
                        <PhoneInputWithDialCode
                            v-model="formData.payload.phone"
                            :country-name="selectedCountry.name"
                            :country-code="selectedCountry.dialCode"
                            :country-flag="selectedCountry.flag"
                            type="tel"
                        />
                    </div>
    
                    <p v-for="error in getValidationErrors('payload.phone')" :key="error" class="text-red-500 text-sm">
                        {{ error }}
                    </p>
                </div>
                <div class="mb-3 z-50">
                    <label 
                        for="name" class="block text-sm font-semibold text-primary-font"
                    >
                        First Name
                    </label>
                    <Input
                        id="first_name"
                        type="text"
                        v-model="formData.payload.first_name"
                        placeholder="Enter your first name"
                        class="shadow-none border border-primary-border"
                        
                    />
                    <p v-for="error in getValidationErrors('payload.first_name')" :key="error" class="text-red-500 text-sm">
                        {{ error }}
                    </p>
                </div>
                <div class="mb-3 z-50">
                    <label for="name" class="block text-sm font-semibold text-primary-font"
                        >Last Name</label
                    >
                    <Input
                        id="last_name"
                        type="text"
                        v-model="formData.payload.last_name"
                        placeholder="Enter your last name"
                        class="shadow-none border border-primary-border"
                    />
                    <p v-for="error in getValidationErrors('payload.last_name')" :key="error" class="text-red-500 text-sm">
                        {{ error }}
                    </p>
                </div>
                
                <div class="mb-3">
                    <div class="flex justify-between">
                        <label
                        for="email"
                        class="block text-sm font-semibold text-primary-font"
                    >
                        Email
                    </label>
                    <span class="font-medium text-sm text-sub">
                        Optional
                    </span>
                    </div>
                    
                    <Input
                        id="email"
                        type="email"
                        v-model="formData.payload.email"
                        placeholder="Enter your email"
                        required
                        autocomplete="current-email"
                        class="shadow-none border border-primary-border"
                    />
                    <p v-for="error in getValidationErrors('payload.email')" :key="error" class="text-red-500 text-sm">
                        {{ error }}
                    </p>
                </div>

                <div class="mb-3">
                    <div class="flex items-center gap-2">
                        <Checkbox
                            id="accept_terms"
                            v-model="formData.accept_terms"
                            @change="toggleAcceptTerms"
                        />
                        <label for="accept_terms" class="block text-sm text-primary-gray">
                            I agree to the 
                            <a class="font-medium text-primary-font underline" :href="termsUrl" target="_blank">Terms & Conditions</a> and
                            <a class="font-medium text-primary-font underline" :href="privacyPolicyUrl" target="_blank">Privacy Policy</a>
                        </label>
                    </div>
                    <p v-for="error in getValidationErrors('accept_terms')" :key="error" class="text-red-500 text-sm">
                        {{ error }}
                    </p>
                </div>
    
                <div class="flex justify-end gap-2 mt-5 mb-5">
                    <button
                        @click="submitUserInfo"
                        :disabled="isLoading"
                        class="w-full text-sm py-2 px-4 bg-primary-green text-white font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-[#41AE49]"
                    >
                        <span v-if="isLoading">Processing...</span>
                        <span v-else>Continue</span>
                    </button>
                </div>

                <div class="flex flex-col items-center gap-2 text-sm">
                    <p class="text-primary-gray">Have an account?</p>
                    <a :href="loginUrl" target="_blank" class="font-medium text-primary-font underline">
                        Login
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref } from "vue";
    import { useConfig } from "@/composables";
    import { useSignupWizardStore } from "@/store";
    import { storeToRefs } from "pinia";
    import HeaderIcon from "./components/HeaderIcon.vue";
    import Intro from "./components/Intro.vue";
    import PhoneInputWithDialCode from "./components/PhoneInputWithDialCode.vue";
    import Input from "@/components/ui/input/Input.vue";
    import Checkbox from "@/components/ui/checkbox/Checkbox.vue";
    

    const signupWizardStore = useSignupWizardStore();

    const {isLoading, formData, selectedCountry} = storeToRefs(signupWizardStore);
    const {setFormData, submitUserInfo, selectCountry, getValidationErrors, fetchSignupState, toggleAcceptTerms} = signupWizardStore;
    const {termsUrl, privacyPolicyUrl, loginUrl} = useConfig();

    const headingText = "Get started with CoAmana";
    const subText = "Enter your details to continue. This takes less than a minute.";

    onMounted(async () => {
        await fetchSignupState()
    })
</script>
